import { createContext } from "react";

import { BookingDTO } from "types/bookings";

export default createContext<{
  openEditModal?: (booking: BookingDTO) => void;
  hoveredBookingID?: string;
  setHoveredBookingID?: (bookingID?: string) => void;
}>({});
